/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/anopro/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    if (window.location.pathname === "/sections") {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  var onClickSections = {};

  const { dropdownHoverColor } = props;
  const classes = useStyles();
  return (
    <List className={classes.list + " " + classes.mlAuto}>
{/*
      <ListItem className={classes.listItem}>
        <Button
          onClick={e => e.preventDefault()}
          color="transparent">
          <Link to="/message" className={classes.dropdownLink2}>はじめての方へ</Link>
        </Button>
      </ListItem>
*/}
{/*
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="サービス"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          // buttonIcon={ViewCarousel}
          dropdownList={[
            <Link to="/about-us" className={classes.dropdownLink}>
              共創ワークショップ入門
            </Link>,
            <Link to="/management" className={classes.dropdownLink}>
              マネージメント研修
            </Link>
          ]}
        />
      </ListItem>
*/}
{/*
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="コラム"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          // buttonIcon={ViewDay}
          dropdownList={[
            <Link
              to="/columns-all"
              className={classes.dropdownLink}
              onClick={e => smoothScroll(e, "headers")}
            >
              全て
            </Link>,
            <Link
              to="/columns-process"
              className={classes.dropdownLink}
              onClick={e => smoothScroll(e, "features")}
            >
              プロセス設計
            </Link>
          ]}
        />
      </ListItem>
*/}
      <ListItem className={classes.listItem}>
        <Button
          onClick={e => e.preventDefault()}
          color="transparent"
        >
          <Link to="/contact" className={classes.dropdownLink2}>コンタクト</Link>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          // href="#pablo"
          onClick={e => e.preventDefault()}
          color="transparent"
        >
          <Link to="/profile" className={classes.dropdownLink2} >プロフィール</Link>
        </Button>
      </ListItem>
      {/* <ListItem className={classes.listItem}>
        <Button
          href="https://www.creative-tim.com/product/material-kit-pro-react?ref=mkpr-navbar"
          color={window.innerWidth < 960 ? "info" : "white"}
          target="_blank"
          className={classes.navButton}
          round
        >
          <ShoppingCart className={classes.icons} /> buy now
        </Button>
      </ListItem> */}
    </List>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary"
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ])
};
